'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var deepclone = function deepclone(target) {
  var value = void 0;
  var key = void 0;

  var clonedTarget = Array.isArray(target) ? [] : {};

  /* eslint-disable */
  for (key in target) {
    value = target[key];
    clonedTarget[key] = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? deepclone(value) : value;
  }
  /* eslint-enable */

  return clonedTarget;
};

exports.default = deepclone;